import union from 'lodash/union'
import without from 'lodash/without'
import { APP_SAVING_ACTIVATE, APP_SAVING_DEACTIVATE } from './actions'

const initialState = {
  activators: []
}

export default (state = initialState, action) => {
  switch (action.type) {
    case APP_SAVING_ACTIVATE:
      return {
        activators: union(state.activators, [action.initiator])
      }

    case APP_SAVING_DEACTIVATE:
      return {
        activators: without(state.activators, action.initiator)
      }

    default:
      return state
  }
}
